import React from 'react'
import { motion } from "framer-motion"

import { transitionPages } from "./utils/animations"
import ComponentContainer from './utils/ComponentContainer';

const variantsList ={
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      },
      
    }
  }

  const item = {
    hidden: { opacity: 0, y: -50 },
    show: { opacity: 1, y: 0 },
    transition: { ease: "easeInOut" }
  };

const Like = () => {
    return (
        <ComponentContainer>
            <motion.main 
            initial={transitionPages.initial}
            exit={transitionPages.exit}
            animate={transitionPages.animate}
            transition={transitionPages.transition}
            className="like">
                <div className="like__visuals">
                    <h1>Most liked places</h1>

                    <section>
                        <motion.ul 
                        className="like__visuals__list"
                        initial="hidden"
                        animate="show"
                        variants={variantsList}
                        >
                            <motion.li
                                variants={item}
                            >
                                <div className="like__visuals__list__image">
                                    <img src="https://images.otstatic.com/prod/24897887/1/large.jpg" alt="photo"/>
                                    <div style={{overflow: 'hidden'
                                    }} >
                                        <svg viewBox="220 0 300 150" preserveAspectRatio="none" style={{height: '100%', width: 'auto'}}>
                                            <path d="M352.42,166.28 C500.84,155.42 391.92,-29.11 514.95,-13.31 L511.00,189.95 L0.00,150.00 Z" style={{stroke: 'none', fill:'#fff'}}></path>
                                        </svg>
                                    </div>
                                </div>
                                <div className="like__visuals__list__content">
                                    <h2>Olio e Piú</h2>
                                    <p>Our team has put several protocols into place including frequent and thorough sanitizing of all tables, chairs, and bathrooms; social distancing; HVAC systems upgraded with HEPA filters and air purifiers.</p>
                                </div>
                            </motion.li>
                            <motion.li
                                variants={item}
                            >
                                <div className="like__visuals__list__image">
                                    <img src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="photo"/>
                                    <div style={{overflow: 'hidden'
                                    }} >
                                        <svg viewBox="220 0 300 150" preserveAspectRatio="none" style={{height: '100%', width: 'auto'}}>
                                            <path d="M352.42,166.28 C500.84,155.42 391.92,-29.11 514.95,-13.31 L511.00,189.95 L0.00,150.00 Z" style={{stroke: 'none', fill:'#fff'}}></path>
                                        </svg>
                                    </div>
                                </div>
                                <div className="like__visuals__list__content">
                                    <h2>Piccola Cucina</h2>
                                    <p>Similique sunt aliquid numquam quisquam! Deleniti sint vel reprehenderit dignissimos ducimus laudantium quisquam veritatis, impedit error quod doloribus, magnam quae dicta!</p>
                                </div>
                            </motion.li>
                            <motion.li
                                variants={item}
                            >
                                <div className="like__visuals__list__image">
                                    <img src="https://images.unsplash.com/photo-1550966871-3ed3cdb5ed0c?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80" alt="photo"/>
                                    <div style={{overflow: 'hidden'
                                    }} >
                                        <svg viewBox="220 0 300 150" preserveAspectRatio="none" style={{height: '100%', width: 'auto'}}>
                                            <path d="M352.42,166.28 C500.84,155.42 391.92,-29.11 514.95,-13.31 L511.00,189.95 L0.00,150.00 Z" style={{stroke: 'none', fill:'#fff'}}></path>
                                        </svg>
                                    </div>
                                </div>
                                <div className="like__visuals__list__content">
                                    <h2>E.A.K. Ramen</h2>
                                    <p>Harum minus vitae in veniam temporibus culpa cupiditate molestiae minima, assumenda quod cumque ad ea? Possimus quos labore harum veniam! Facilis, dolorem? Qui cumque vitae nulla, sapiente blanditiis, pariatur nisi officiis quasi et consectetur.</p>
                                </div>
                            </motion.li>
                        </motion.ul>
                    </section>
                </div>
            </motion.main>
        </ComponentContainer>
    )
}

export default Like
